module.exports = __webpack_public_path__ + "static/img/role009.8330d18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/role009.jpg
// module id = kc3U
// module chunks = 1